import { Component, OnInit, TemplateRef, Input, Output, EventEmitter } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { JqHelper } from 'src/app/common/jq-helper';
import { UnitOfWorkService } from 'src/app/services/api/uow/unit-of-work.service';
import { GVechileViewModel } from 'src/app/viewmodels/g-vehicle/GVechileViewModel';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { ItemViewModel, ItemViewModel1 } from 'src/app/viewmodels/ItemViewModel';
import { AccountDefiningModel, DefineAccountviewModel } from 'src/app/viewmodels/g-customer/DefineAccountviewModel';
import { Router } from '@angular/router';
import { G_TagsViewModel } from 'src/app/viewmodels/g-settings/G_TagsViewModel';
import { G_SaleMasterViewModel } from 'src/app/viewmodels/g-sale/G_SaleMasterViewModel';
import { NgxSpinnerService } from "ngx-spinner";
import Swal from 'sweetalert2';
import { SaveSaleMasterRequest } from 'src/app/viewmodels/g-purchase/GPurchaseViewModel';
import { GVehicleModel } from 'src/app/viewmodels/g-sale/GSaleViewModel';
import { SaveGVehicleRequest, SaveTagRequest } from 'src/app/viewmodels/g-settings/GSettingViewModel';
@Component({
  selector: 'app-sale-comp',
  templateUrl: './sale-comp.component.html',
  styleUrls: ['./sale-comp.component.scss']
})
export class SaleCompComponent implements OnInit {

  modalRefLv1: BsModalRef;
  modalRefLv2: BsModalRef;
  modalRefLv3: BsModalRef;
  modalRef: BsModalRef;
  public vmListItems: any = [];
  @Input() public modal_title: any;
  @Input() public vmP: AccountDefiningModel;
  @Input() public vm: SaveSaleMasterRequest;
  private submitted = false;
  public component_Title = 'Sale';
  public vehicleDetail: any = [];
  public cvehicleDetail = 'vehicleDetail';
  public selectedvehicleDetail: any = [];
  public itemVm: SaveGVehicleRequest = new SaveGVehicleRequest();
  bsmRef: any;
  @Output() onSubmitted = new EventEmitter<any>();
  public tags: any = [];
  public selectedTagList: any = [];

  constructor(
    private _jq: JqHelper,
    private _uow: UnitOfWorkService,
    private _modalService: BsModalService,
    public _router: Router,
    private spinner: NgxSpinnerService
  ) { }

  public defaultDropdownSettings: IDropdownSettings = {
    singleSelection: true,
    idField: 'id',
    textField: 'registrationNumber',
    enableCheckAll: false,
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };

  public itemsDropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'name',
    enableCheckAll: false,
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };

  ngOnInit() {
    if (this.vmP == undefined) {
      this.vmP = new AccountDefiningModel();
      this._uow.gSettingService.LoadAccountFormAsync().subscribe((res: any) => {
        this.vmP.accCode = res.code;
      }, (err) => {
        console.log(err);
      });
    }
    if (this.itemVm.tagList !== undefined && this.itemVm.tagList.length > 0) {
      this.itemVm.tagList.forEach(x => {
        this.selectedTagList.push(new ItemViewModel1(x.id, x.name));
      });
    }
    if (this.itemVm == undefined) {
      this.itemVm = new SaveGVehicleRequest();
      this.vehicleDetail = [];
      this.selectedvehicleDetail = [];
    } else {

    }
    if (this.modal_title == undefined) {
      this.modal_title = 'Sale';
    }
    // this.getList();
    this.getRegNo();
    //this.getRequisitions();
    this.getTags();
    // this.getVehicleDetail();
    // this.selectedvehicleDetail();
    // this.saveOrUpdate();
  }

  getRegNo() {
    this.spinner.show();
    this._uow.gSettingService.GetGVehiclesByUserAsync().subscribe((res: any) => {
      this.vehicleDetail = res.result;
      this.spinner.hide();
    }, (error) => {
      this._uow.logger.log(error);
      this.spinner.hide();
    });
  }

  // getRequisitions() {
  //   console.log(this.selectedvehicleDetail);
  //   this._uow.vehicleService.GetList().subscribe((res: any) => {
  //     console.log(res);
  //     this.vehicleDetail = res;
  //   }, (error) => {
  //     this._uow.logger.log(error);
  //     this.vehicleDetail = [];
  //   });
  // }

  onSelectvehicleDetail(e) {
    debugger
    this._uow.logger.log(e);
    let item = this.vehicleDetail.find(x => x.id === e.id);
    this.itemVm = item;
    this.itemVm.name = item.name;
    this.itemVm.registrationNumber = item.registrationNumber;
    this.itemVm.tagList = item.tagList;
    //   this._uow.vehicleService.GetById(e.Id).subscribe((res: any) => {
    //   console.log(res);
    //   console.log(this.itemVm);
    //   this.itemVm = res;
    //   this.itemVm.Name = res.Name;
    //   this.itemVm.RegistraionNumber = res.RegistraionNumber;
    //   this.itemVm.FK_Tag_List  = res.FK_Tag_List;
    //   console.log(this.itemVm);
    // }, (err) => {
    //   console.log(err);
    // });

  }

  onDeSelectvehicleDetail(e) {
    if (this.selectedvehicleDetail.length == 0) {
      this.itemVm = new SaveGVehicleRequest();
      this.itemVm.registrationNumber = this.itemVm.registrationNumber;
      this.getRegNo();
    }
  }

   getTags() {
    this.spinner.show();
    this._uow.gSettingService.GetTagsAsync().subscribe((res: any) => {
      this.tags = res.result;
      this.spinner.hide();
    },
      (err) => {
        console.log(err);
        this.spinner.hide();

      });
  }

   onSelectTags(e) {
    if (this.itemVm.tagList == undefined || this.itemVm.tagList.length == 0) {
      this.itemVm.tagList = [];
    }
    this._uow.logger.log(e);
    const item = this.tags.find(x => x.id === e.Ii);
    if (item !== undefined) {
      const a = new SaveTagRequest();
      a.id = item.id;
      a.name = item.name;
      this.itemVm.tagList.push(a);
    }

  }

  onDeSelectTags(e) {
    const i = this.itemVm.tagList.find(x => x.id === e.id);
    if (i !== undefined) {
      this.itemVm.tagList.splice(this.itemVm.tagList.indexOf(i), 1);
    }

  }

  // getVehicleDetail() {
  //   // 'Spare-Parts'
  //   this.spinner.show();
  //   this._uow.vehicleService.GetById('Vehicle-Detail').subscribe((res: any) => {
  //     this.vehicleDetail = res;
  //     console.log(res);
  //     this.spinner.hide();
  //   }, (err) => {
  //     this._uow.logger.log(err);
  //     this.vehicleDetail = [];
  //     this.spinner.hide();
  //   });
  // }


  openModal(template: TemplateRef<any>, lvl: number) {
    if (lvl == 1) {
      this.modalRefLv1 = this._modalService.show(template);
      this.modalRefLv1.setClass('modal-lg');
    }
    if (lvl == 2) {
      this.modalRefLv2 = this._modalService.show(template);
    }
    if (lvl == 3) {
      this.modalRefLv3 = this._modalService.show(template);
    }
  }



  openSaveOrUpdateModel(template: TemplateRef<any>, model?) {
    this.openModal(template, 1);
    if (model !== undefined) {
      this.itemVm = model;
    } else {
      this.itemVm = new SaveGVehicleRequest();
    }
  }

 

 

  saveOrUpdate() {
    // this._jq.showSpinner(true);
    this.spinner.show();
    this._uow.gSettingService
      //.Post(this.itemVm)
      .SaveGVehicleAsync(this.itemVm)
      .toPromise().then((res: any) => {
        console.log(res);
        this.submitted = true;
        this.onSubmitted.emit(this.submitted);
        // this._jq.showSpinner();
        this.spinner.hide();

        Swal.fire(
          'Updated!',
          'Vehicle Updated!',
          'success'
        )
        // this.bsmRef.hide();
        this._router.navigate(['/repair-order', { id: this.itemVm.uniqueId }]);
      })
      .catch((error) => {
        Swal.fire(
          'Failure!',
          'Vehicle Not Updated!',
          'error'
        )
        console.log(`Promise rejected with ${JSON.stringify(error)}`);
        this.onSubmitted.emit(false);
        // this._jq.showSpinner();
        this.spinner.hide();

      });
  }

  // saveOrUpdate() {
  //   this._jq.showSpinner(true);
  //   this._uow.vehicleService.Post(this.vm).subscribe((res: any) => {
  //     this.getList();
  //     this.modalRefLv1.hide();
  //   }, (err) => {
  //     this._jq.showSpinner();
  //   });
  // }

  openDeleteModel(template: TemplateRef<any>, model) {
    this.openModal(template, 1);
    if (model !== undefined) {
      this.itemVm = model;
    }
  }

  conformDelete() {
    this.spinner.show();
    this._uow.vehicleService.Delete(null).subscribe((res: any) => {
      this.getList();
      this.modalRefLv1.hide();
      this.spinner.hide();
    }, (err) => {
      this.spinner.hide();
    });
  }

  // external components
  onItemSubmitted(e) {
    if (e == true) {
      this.getList();
      this.getTags();
      this.spinner.hide();
    }
  }

  getList() {
    this.spinner.show();
    this._uow.gSettingService.GetGVehiclesByUserAsync().subscribe((res: any) => {
      this.vmListItems = res.result;
      console.log(res);
      this.spinner.hide();

    }, (err) => {
      console.log(err);
      this.spinner.hide();

    });
  }

}
